export default __webpack_public_path__ + "static/media/mempools.6a0f1fd6.png";